import React from 'react';
import { FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';

interface EstimateStatusBadgeProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
}

const EstimateStatusBadge: React.FC<EstimateStatusBadgeProps> = ({
  status,
  size = 'md',
}) => {
  const base = 'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium';

  const getStatusConfig = () => {
    switch (String(status || '').toLowerCase()) {
      case 'approved':
        return {
          label: 'Approved',
          icon: FiCheckCircle,
          className: `${base} bg-green-50 text-green-700 ring-1 ring-green-200`
        };
      case 'rejected':
        return {
          label: 'Rejected',
          icon: FiXCircle,
          className: `${base} bg-red-50 text-red-700 ring-1 ring-red-200`
        };
      case 'pending':
      default:
        return {
          label: 'Pending',
          icon: FiClock,
          className: `${base} bg-amber-50 text-amber-800 ring-1 ring-amber-200`
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };
  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <span className={`${config.className} ${sizeClasses[size]}`}>
      <Icon className={`mr-1.5 ${iconSizes[size]}`} />
      {config.label}
    </span>
  );
};

export default EstimateStatusBadge;
